import { FetchdRetailerApiData, LookupRetailerApiResponse } from './lookupRetailerApi.types';
import { LOOKUP_API_PARAMS, performRequest } from './lookupRetailerApi.utils';

const CACHE_TTL = 4 * 60 * 60 * 1000; // Four hour cache of lookup results - our bearer token lasts 24 hours
const fetchRetailerApiData: FetchdRetailerApiData = {};

export const fetchRetailerApiSettings = async (): Promise<LookupRetailerApiResponse> => {
    const params = LOOKUP_API_PARAMS;

    // Return cached data if it hasn't expired
    if (fetchRetailerApiData.cache && Date.now() < fetchRetailerApiData.cache.expires) {
        return fetchRetailerApiData.cache.data;
    }

    // Check if there's already a pending request for this key
    if (fetchRetailerApiData.pendingRequest) {
        // Return the existing pending request
        return fetchRetailerApiData.pendingRequest;
    }

    // Create new request and store in pending requests
    const requestPromise = (async () => {
        try {
            const data = await performRequest(params);

            fetchRetailerApiData.cache = {
                data,
                expires: Date.now() + CACHE_TTL,
            };

            return data;
        } finally {
            // Clean up pending request
            fetchRetailerApiData.pendingRequest = undefined;
        }
    })();

    fetchRetailerApiData.pendingRequest = requestPromise;

    return requestPromise;
};
